<template>
  <!-- 直播间优惠券推荐 -->
  <div class="recommendsPopup">
    <div v-show="show" :class="['contentBox', { isFullScreen: isFullScreen }]">
      <div class="mainBox">
        <img class="close" @click="close" src="@/assets/img/live/close01.png" alt="" />
        <div class="box" v-if="recommendType === 0 && productInfo">
          <div class="courseInfo" @click="jumpPageCourse()">
            <img class="courseImg" :src="productInfo.coverMobile" alt="" />
          </div>
        </div>
        <div class="box" v-if="recommendType === 1 && packageInfo">
          <div class="courseInfo" @click="jumpPagePackage()">
            <img class="courseImg" :src="packageInfo.coverMobile" alt="" />
          </div>
        </div>
        <div class="couponBox" v-else-if="recommendType === 2 && couponInfo">
          <div class="couponBoxMain">
            <div class="couponDiscount">
              <p class="discountAmount" v-if="couponInfo.discountType === 1">
                <span>￥</span>{{ couponInfo.discountAmount }}
              </p>
              <p class="discountAmount" v-else>{{ couponInfo.discountAmount }}<span>折</span></p>
              <p>满{{ couponInfo.usableCondition }}可用</p>
            </div>
            <div class="couponTitle">
              <img
                v-if="couponInfo.fitUser === 2"
                class="new-user"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/player/new-user.png"
                alt=""
              />
            </div>
          </div>
          <p class="frontEndName">{{ couponInfo.frontEndName }}</p>
          <p class="status">
            <span >{{showType(couponInfo.productionFitType,couponInfo.packageFitType)}}</span>
          </p>

          <p class="time" v-if="couponInfo.effectiveTimeType === 1">领取后{{ couponInfo.effectiveDays }}天内有效</p>
          <p class="time noWarrp" v-else-if="couponInfo.effectiveTimeType === 2">
            {{ detailTime(couponInfo.effectiveTimeBegin) }}-{{
              detailTime(couponInfo.effectiveTimeEnd)
            }}
          </p>
          <p class="time" v-else-if="couponInfo.effectiveTimeType === 3">领取后当天有效</p>
          <p class="time" v-else-if="couponInfo.effectiveTimeType === 4">领取后{{ couponInfo.effectiveHours }}小时内有效</p>
        </div>
        <div
          :class="['footBg', robGet === 1 ? 'courseRob' : 'couponRob']"
          @click="robGet === 1 ? jumpPage() : receiveCoupon()"
        >
          <div
            v-if="robGet === 1"
            class="coursePrice"
            v-html="recommendType === 0 ? productPrice() : packagePrice()"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { liveRecommendPolling, reqliveRecommended, reqRecommendCoupon } from '@/api/live/index';
import { reqCombinationlist } from '@/api/combination';
import { reqReceiveCoupon } from '@/api/coupon/index';
import { dateTime } from '@/utils/tools';

export default {
  data() {
    return {
      timer: null,
      show: false, //弹窗显隐
      closedId: null, //上一次关闭过的弹窗id
      couponInfo: {}, //优惠券
      productInfo: {}, //课程信息
      packageInfo: {}, //套餐信息
      recommendType: null, //推荐类型
      hrefType: null, // 0 课程详情页  1 订单页
      liveRoomId: this.$route.query.roomId, //直播间ID
      lastCoupon: null,
      dialogTimer: null,
    };
  },
  props: {
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    isAlertRecommend: {
      type: Number,
      default: 0,
    },
    liveCouponList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    robGet() {
      // type 1 课程弹窗按钮马上抢 2优惠券弹窗按钮立即领取
      let type = 1;
      if (this.productInfo && (this.recommendType === 0 || this.recommendType === 1)) {
        type = 1;
      } else if (this.couponInfo && this.recommendType === 2) {
        type = 2;
      }
      return type;
    },
  },
  methods: {
    async init() {
      let liveId = this.$route.query.liveId || this.$route.params.resourceId;
      this.timer = null;
      this.timer = setInterval(async () => {
        console.log(33333333, this.isAlertRecommend);
        this.getRecommendPopup(liveId);
        this.getCouponPopup(liveId);
      }, 5000);
    },
    async getRecommendPopup(liveId) {
      if (!this.isAlertRecommend) return;
      const { code, data } = await liveRecommendPolling({ liveId });
      if (code !== 0) return;
      const { recommendType, isAlertRecommend, recommendCoupon, productId, packageId } = data;
      if (isAlertRecommend === 0) {
        this.show = false;
        this.closedId = null;
        return;
      } //无弹窗
      this.recommendType = recommendType;
      //0、产品 1、套餐 2、优惠券
      if (recommendType === 0) {
        //产品
        if (this.productInfo?.productId !== this.closedId){
          this.productDetail(productId);
        }
      } else if (recommendType === 1) {
        //套餐
        if (this.packageInfo?.packageId !== this.closedId){
          this.packageDetail(packageId);
        }
      } else {
        //优惠券
        this.couponInfo = recommendCoupon;
        if (this.couponInfo?.couponId !== this.closedId) {
          this.show = true;
          clearTimeout(this.dialogTimer)
          this.hideDialog();
        }
      }
    },
    hideDialog() {
      const { recommendType, productInfo, packageInfo, couponInfo } = this;
      this.closedId =
        recommendType === 0
          ? productInfo?.productId
          : recommendType === 1
          ? packageInfo?.packageId
          : couponInfo?.couponId;
      this.dialogTimer=setTimeout(() => {
        this.close();
      }, 6000);
    },
    async getCouponPopup(liveId) {
      if (!this.isFullScreen) return;
      const { data } = await reqRecommendCoupon(liveId);
      console.log(this.liveCouponList, data, 33333);
      if (!this.liveCouponList.length || !data) return;
      const hasGetAlreadyList = this.liveCouponList.filter((ele) => {
        return ele.hasGetAlready == 1;
      });
      const findRes = hasGetAlreadyList.find((ele) => {
        return ele.couponId == data?.couponId;
      });
      console.log(hasGetAlreadyList, findRes, 4444);
      // 这次的券和昵称和上次一样 不弹窗
      if (
        this.lastCoupon?.nickName === data?.nickName &&
        this.lastCoupon?.couponName === data?.couponName
      ) {
        console.log('和上次一样');
        return;
      }
      // 这次的券 用户领取过不谈
      if (findRes) {
        console.log('用户领取了');
        return;
      }
      const receiveCouponId = window.sessionStorage.getItem('receiveCouponId');
      if (receiveCouponId && receiveCouponId == data?.couponId) {
        return;
      }
      const liveEffect = window.localStorage.getItem(`liveEffect${liveId}`);
      if (liveEffect) return;
      this.$emit('showPopupCoupon', data);
      this.lastCoupon = data;
      console.log(hasGetAlreadyList, data);
    },
    async productDetail(productId) {
      const { data } = await reqliveRecommended([productId]);
      if (data?.length) {
        this.productInfo = data[0];
        if (this.productInfo?.productId !== this.closedId) {
          this.show = true;
          clearTimeout(this.dialogTimer)
          this.hideDialog();
        }
      }
    },
    async packageDetail(packageId) {
      const { data } = await reqCombinationlist(0, 4, [packageId]);
      if (data?.length) {
        this.packageInfo = data[0];
        if (this.packageInfo?.packageId !== this.closedId) {
          this.show = true;
          clearTimeout(this.dialogTimer)
          this.hideDialog();
        }
      }
    },
    close() {
      const { recommendType, productInfo, packageInfo, couponInfo } = this;
      this.closedId =
        recommendType === 0
          ? productInfo?.productId
          : recommendType === 1
          ? packageInfo?.packageId
          : couponInfo?.couponId;
      this.show = false;
    },
    productPrice() {
      //计算课程价格
      const { productDiscountRespVO = {}, sellPrice = 0 } = this.productInfo;
      const {
        isGroupDiscount,
        discountPrice,
        discountMinPrice,
        isCouponDiscount,
        couponDiscount,
        promotionLabel,
      } = productDiscountRespVO;
      if (isGroupDiscount) {
        //拼团价
        return `<span>拼团价</span><b>￥${discountMinPrice}</b>`;
      } else if (isCouponDiscount && couponDiscount && !promotionLabel && sellPrice > 0) {
        //券后价
        return `<span>券后价</span><b>￥${discountPrice}</b>`;
      } else if (!promotionLabel && sellPrice === 0) {
        //限时免费
        return `<b>限时免费</b>`;
      } else if (!promotionLabel && sellPrice > 0) {
        //正价课
        return `<b>￥${sellPrice}</b>`;
      } else if (promotionLabel === 1) {
        //直降
        return `<span>折后价</span><b>￥${discountMinPrice}</b>`;
      } else {
        return `<span>限时价</span><b>￥${discountMinPrice}</b>`;
      }
    },
    packagePrice() {
      //计算套餐价格
      const { packageDiscountRespVO = {}, sellPrice = 0 } = this.packageInfo;
      const { isCouponDiscount, isGroupDiscount, promotionLabel, payPrice } = packageDiscountRespVO;
      if (isGroupDiscount) {
        return `<span>拼团价</span><b>￥${payPrice}</b>`;
      } else if (isCouponDiscount && !promotionLabel && sellPrice > 0) {
        //券后价
        return `<span>券后价</span><b>￥${payPrice}</b>`;
      } else if (!promotionLabel && sellPrice === 0) {
        //限时免费
        return '<b>限时免费</b>';
      } else if (!promotionLabel && sellPrice > 0) {
        //正价课
        return `<b>￥${sellPrice}</b>`;
      } else if (promotionLabel === 1) {
        //直降
        return `<span>折后价</span><b>￥${payPrice}</b>`;
      } else {
        return `<span>限时价</span><b>￥${payPrice}</b>`;
      }
    },
    jumpPage() {
      const { recommendType, productInfo } = this;
      if (recommendType === 0) {
        if (productInfo.skipType === 1) {
          //详情页  2 订单页
          this.jumpPageCourse();
        } else {
          const query = [
            {
              productId: productInfo.productId,
              skuId: productInfo.productSkuSimpleVOS[0]?.productSkuId,
            },
          ];
          this.$router.push({
            path: 'payOrder',
            query: {
              product: JSON.stringify(query),
              liveRoomId: this.liveRoomId,
            },
          });
        }
      } else {
        //套餐页面
        this.jumpPagePackage();
      }
    },
    jumpPageCourse() {
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: this.productInfo.productId,
          liveRoomId: this.liveRoomId,
        },
      });
    },
    jumpPagePackage() {
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/combinationCourse',
        query: {
          combinationId: this.packageInfo.packageId,
          liveRoomId: this.liveRoomId,
        },
      });
    },
    async receiveCoupon() {
      //领取优惠券
      const data = await reqReceiveCoupon({
        couponId: String(this.couponInfo.couponId),
        fitPlatform: 1,
        fitEndPoint: 4,
        isLink: 0,
        terminalMark: this.$global.terminalMark,
      });
      if (data.code === 0) {
        this.$toast('优惠券领取成功，请在个人中心查看');
      } else {
        this.$toast(`${data.msg}`);
      }
      this.close();
    },
    detailTime(time) {
      const { year, month, day, h, m } = dateTime(new Date(time.replace(/-/g, '/')).getTime());
      return `${year}.${month}.${day}`;
    },
    showType(type, status) {
      const typeMap = {
        1: '所有产品',
        2: '指定产品可用',
        3: '指定产品可用',
      };
      let text = typeMap[type] || '';
      if (status === 4) {
        text = type === 1 ? '所有产品' : '指定产品可用';
      } else if (status === 5) {
        text = '指定产品可用';
      }
      return text;
    },
  },

  mounted() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="scss">
.recommendsPopup {
  .isFullScreen.contentBox {
    bottom: 60px;
    // left: 80px;
  }
  .contentBox {
    position: fixed;
    right: 36px;
    bottom: 220px;
    z-index: 120;
    box-sizing: border-box;
    width: 290px;
    height: 389px;
    padding: 36px 22px 22px 22px;
    background: linear-gradient(180deg, #fffaf1 0%, #fff2df 100%);
    border-radius: 14px;
    box-shadow: 0 4 9px 0 rgba(82, 64, 64, 0.2);
    .mainBox {
      // position: fixed;
      // width: 290px;
      // height: 389px;
      // background: url('../../../assets/img/live/popbg01.png') no-repeat;
      // background-size: 100% 100%;

      .close {
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 2;
        width: 29px;
        height: 29px;
      }
      .box {
        // position: absolute;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // box-sizing: border-box;
        // width: 458px;
        // height: 573px;
        // padding-left: 22px;
        .courseInfo {
          z-index: 1;
          // margin-top: 235px;
          text-align: center;
          .courseImg {
            width: 252px;
            height: 182px;
            border-radius: 14px;
          }
        }
      }
      .couponBox {
        // box-sizing: border-box;
        // width: 290px;
        // height: 389px;
        // margin: 0 auto;

        .couponBoxMain {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 246px;
          height: 118px;
          background: url('../../../assets/img/live/couponbg01-1.png') no-repeat;
          background-size: 100% 100%;
          .couponDiscount {
            box-sizing: border-box;
            // width: 140px;
            padding-left: 20px;
            p {
              color: #b77026;
              font-weight: 400;
              font-size: 18px;
              line-height: 25px;
              text-align: center;
            }
            .discountAmount {
              margin-bottom: 10px;
              color: #f02;
              font-size: 36px;
              span {
                font-size: 25px;
              }
            }
          }
          .couponTitle {
            box-sizing: border-box;
            width: 69px;
            padding: 0 22px 0 0;
            p {
              width: 100%;
            }
            .new-user {
              width: 29px;
              height: 100px;
            }

            .noWarrp {
              letter-spacing: -0.5px;
              white-space: nowrap;
            }
          }
        }
      }
      .frontEndName {
        display: -webkit-box;
        width: 205px;
        padding: 14px 0 11px 0;
        overflow: hidden;
        color: #333;
        font-weight: 500;
        font-size: 22px;
        line-height: 29px;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .time {
        color: #999;
        font-weight: 400;
        font-size: 20px;
        line-height: 29px;
      }
      .status {
        // margin: 8px 0 10px 0;
        font-size: 0;
        span {
          color: #999;
          font-size: 22px;
        }
      }
      .footBg {
        position: absolute;
        right: 0;
        bottom: 22px;
        left: 0;
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 246px;
        height: 51px;
        margin: 0 auto;
        p {
          width: 100%;
          height: 100%;
        }
      }
      .courseRob {
        width: 252px;
        height: 78px;
        background: url('../../../assets/img/live/rob01.png') no-repeat;
        background-size: 100% 100%;
      }
      .couponRob {
        background: url('../../../assets/img/live/get01.png') no-repeat;
        background-size: 100% 100%;
      }
      .coursePrice {
        z-index: 10;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        box-sizing: border-box;
        width: 252px;
        height: 78px;
        padding-left: 22px;
        color: #e94913;
        ::v-deep span {
           display: inline-block;
          width: 100%;
          color: #fff;
          font-size: 22px;
          opacity: 0.8;
        }
         ::v-deep b {
          display: inline-block;
          width: 100%;
          color: #fff;
          font-weight: 600;
          font-size: 26px;
        }
      }
    }
    // .isFullScreen {
    //   bottom: 5%;
    //   left: 5%;
    //   transform: translateX(0);

    // }
  }
  ::v-deep .van-popup {
    overflow: hidden;
    background: rgba(255, 255, 255, 0);
  }
}
</style>
